<script>
import { mapGetters } from 'vuex'
import allowanceTimeFrame from '@/modules/mixins/allowanceTimeFrame'
import ButtonLoader from '@/components/atoms/ButtonLoader'

export default {
    name: 'AllowanceBlock',
    components: { ButtonLoader },
    mixins: [allowanceTimeFrame],
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        ...mapGetters({
            selectedAllowance: 'allowance',
        }),
        isSelected() {
            return this.selectedAllowance?.id === this.model?.id
        },
        timeLimit() {
            return this.model && this.model.time_value > 1
                ? `${this.model.time_value} ${this.$t(`base.${this.model.time_unit}`)}`
                : this.$t(`base.${this.model.time_unit}`)
        },
    },
    methods: {
        async useAllowance() {
            if (!this.$user.onlyCloudCanteen) {
                this.loading = true
                try {
                    await this.$store.dispatch('setAllowance', this.model)
                    await this.$store.dispatch('getDeliveryPeriod', {
                        allowanceId: this.selectedAllowance?.id,
                    })
                    this.$time.open(true)
                } finally {
                    this.loading = false
                }
            }
        },
        async resetAllowance() {
            if (!this.$user.onlyCloudCanteen) {
                await this.$store.dispatch('resetAllowance')
                await this.$cart.calculate()
            }
        },
    },
}
</script>

<template lang="pug">
    .allowance-block.card(v-if="model" :class="{'border-primary': isSelected}")
        .card-body
            .row
                .col-12.col-lg-8
                    h3 {{model.name}}
                    p.body-sm(v-if="model.description") {{model.description}}
                    .row
                        .col-4
                            span.text-sm.font-weight-medium {{$t('profile.expense_rule.valid')}}
                        .col-8
                            span.text-sm {{$t('profile.expense_rule.valid_until_recalled')}}
                        .col-4
                            span.text-sm.font-weight-medium {{$t('profile.expense_rule.location')}}
                        .col-8
                            span.text-sm {{$t('profile.expense_rule.workplace')}}
                                template(v-if="!model.only_for_company_address") ,&nbsp;{{$t('profile.expense_rule.home')}}
                        .col-4
                            span.text-sm.font-weight-medium {{$t('profile.expense_rule.delivery')}}
                        .col-8
                            div(v-for="interval in timeFrames")
                                span.text-sm {{interval.days}}, {{interval.time}}
                .col-12.col-lg-4.d-flex.flex-column.align-items-end
                    h3.text-right {{ model.budget_limit | toCurrency(model.locale, model.currency_code) }} {{$t('base.per')}} {{timeLimit}}
                    span.text-sm.text-73 {{ model.budget | toCurrency(model.locale, model.currency_code) }} {{$t('profile.expense_rule.today')}}
                    template(v-if="!$user.onlyCloudCanteen")
                        button.btn.btn-warning.btn-xs.mt-auto(v-if="isSelected" @click="resetAllowance") {{$t('profile.expense_rule.discard')}}
                        button-loader.btn.btn-primary.btn-xs.mt-auto(@click="useAllowance" :loading="loading" inline v-else) {{$t('profile.expense_rule.use_now')}}

</template>
